<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="Object.keys(detail).length">
              <div class="content_con">
                <div class="theme_con" @click="toPage('/theme')">
                  <div class="theme_con_img">
                    <img :src="detail.cover_img" />
                  </div>
                  <!-- <div class="theme_con_l">
                    <div class="theme_title">{{ detail.title }}</div>
                    <div><img :src="detail.cover_img" /></div>
                    <div class="theme_eng">{{ detail.sTitle }}</div>
                  </div>
                  <div class="theme_con_r">
                    <div class="time">
                      {{ detail.year }}<strong>{{ detail.themeTime }}</strong>
                    </div>
                    <div class="desc">
                      {{ detail.msg }}
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="theme_con">
                <div class="theme_con_img">
                  <img :src="detail.cover_img" />
                </div>
                <!-- <div class="theme_con_l">
                  <div class="theme_title">{{ detail.title }}</div>
                  <div><img :src="detail.cover_img" /></div>
                  <div class="theme_eng">{{ detail.sTitle }}</div>
                </div>
                <div class="theme_con_r">
                  <div class="time">
                    {{ detail.year }} <strong>{{ detail.themeTime }}</strong>
                  </div>
                  <div class="desc">{{ detail.msg }}</div>
                </div> -->
              </div>
            </div>
          </div></AppcontentList
        >
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab } from '@/const';
import { getPageObj } from '@/assets/api';
export default {
  name: 'Theme',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      currentIndex: 0,
      page: { current: 1, size: 10, total: 20 },
      tabList: themeTab,
      cloumnId: null,
      detail: {},
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    console.log('this.cloumnId', this.cloumnId);
    this.getDetail();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.path });

      // if(){

      // }
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getDetail() {
      getPageObj(this.cloumnId).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 40px 0;
    .content_con {
      background: #fff;
      padding: 30px;
      .theme_con {
        width: 100%;
        height: auto;
        // background: url('../../assets/img/homeimgs/theme_bg.png') no-repeat left
        // top/100% 100%;
        display: flex;
        justify-content: space-between;
        // padding: 2.75rem 7.0625rem;
        .theme_con_img {
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }
        }
        .theme_con_l {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 2;
          .theme_title {
            color: #333333;
            font-size: 1.75rem;
          }
          img {
            width: 17rem;
            height: 10rem;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
          .theme_eng {
            color: #333333;
            font-size: 2.75rem;
          }
        }
        .theme_con_r {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 3;
          .time {
            text-align: right;
            font-size: 2.6875rem;
          }
          .desc {
            text-align: right;
            color: #4d4d4d;
            font-size: 1.375rem;
          }
        }
      }
    }
  }
  .app_content_top {
    width: 100%;
    box-sizing: border-box;

    margin: 2rem 0;
    min-height: 52vh;
    .theme_con {
      margin-top: 2rem;
      width: 100%;
      height: auto;
      background: #fff;
      // background: url('../../assets/img/appImg/theme_bg.png') no-repeat left
      //   top/100% 100%;
      display: flex;
      justify-content: space-between;
      padding: 1.5rem;
      .theme_con_img {
        width: 100%;
        height: auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      .theme_con_l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 2;
        .theme_title {
          color: #333333;
          font-size: 0.9167rem;
        }
        img {
          width: 8.6667rem;
          height: auto;
          object-fit: cover;
          object-position: center; /* 图片的中心与容器的中心对齐 */
        }
        .theme_eng {
          color: #333333;
          font-size: 1.3333rem;
        }
      }
      .theme_con_r {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 3;
        .time {
          text-align: right;
          font-size: 1.3333rem;
        }
        .desc {
          text-align: right;
          color: #4d4d4d;
          font-size: 0.8333rem;
        }
      }
    }
  }
}
.appbg {
  // width: 100%;
  // background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
  //   bottom/100% auto;
}

.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
